export default __webpack_public_path__ + "static/media/warning.ebbc0d84.svg";